"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.formatTime = exports.parseDateWithoutTimeZones = exports.parseDate = exports.convertDateToString = exports.urlParamsToFilters = exports.fetchParamsInURL = exports.removeAllFiltersFromURL = exports.removeFiltersFromURL = exports.applyDateFiltersToURL = exports.applyFiltersToURL = exports.groupColumns = exports.getOrderedColumns = exports.getExportableFields = exports.getOrderedColumnsKeys = exports.transformFilters = exports.dynamicColumns = exports.minRowHeight = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var types_1 = require("./types");
var dayjs_1 = tslib_1.__importDefault(require("dayjs"));
var weekday_1 = tslib_1.__importDefault(require("dayjs/plugin/weekday"));
var localeData_1 = tslib_1.__importDefault(require("dayjs/plugin/localeData"));
var utc_1 = tslib_1.__importDefault(require("dayjs/plugin/utc"));
dayjs_1.default.extend(weekday_1.default);
dayjs_1.default.extend(localeData_1.default);
dayjs_1.default.extend(utc_1.default);
exports.minRowHeight = 45;
// required parameter is used to enforce custom fields
var dynamicColumns = function (schema, custom) {
    if (custom === void 0) { custom = []; }
    if (!schema) {
        return [];
    }
    var dynamicColumns = mapSchema(schema);
    var orderedKeys = [];
    custom.forEach(function (val) {
        orderedKeys.push(val.key);
    });
    dynamicColumns.forEach(function (col, i) {
        custom.forEach(function (c) {
            if (col.key === c.key) {
                dynamicColumns[i] = Object.assign({}, col, c);
            }
        });
    });
    // append custom columns
    custom.forEach(function (col) {
        var found = false;
        dynamicColumns.forEach(function (c) {
            if (col.key === c.key) {
                found = true;
            }
        });
        if (!found) {
            dynamicColumns.push(col);
        }
    });
    // re-order output based on keys
    return sortColumns(dynamicColumns.filter(function (column) { return !((column === null || column === void 0 ? void 0 : column.omit) === true); }), orderedKeys.reverse());
};
exports.dynamicColumns = dynamicColumns;
var flattenObject = function (obj, parent, res) {
    if (res === void 0) { res = {}; }
    for (var key in obj) {
        var fieldKey = parent ? parent + "__" + key : key;
        res[fieldKey] = obj[key];
    }
    return res;
};
var sortColumns = function (arr, keys) {
    return arr.sort(function (a, b) {
        var i = a.key;
        var j = b.key;
        return keys.indexOf(j) - keys.indexOf(i);
    });
};
var mapSchema = function (schema) {
    var dynamicColumns = [];
    var iterate = function (schema, parent) {
        if (parent === void 0) { parent = ""; }
        Object.keys(schema).map(function (key) {
            if (schema[key].type === "object") {
                iterate(flattenObject(schema[key].properties, key), key);
            }
            else {
                dynamicColumns.push({
                    key: key,
                    type: mapType(schema[key]),
                    title: schema[key].title,
                    isVisible: schema[key].isVisible,
                    canCopy: schema[key].format === "uuid",
                    defaultIfNull: "-",
                    dataIndex: parent ? [parent, key.slice(parent.length + 2)] : [key],
                    group: parent,
                });
            }
        });
    };
    iterate(schema);
    return dynamicColumns;
};
var mapType = function (value) {
    switch (value.type) {
        case "boolean":
            return types_1.DATA_TYPE.BOOLEAN;
        case "object":
        case "array":
            return types_1.DATA_TYPE.ARRAY;
        case "number":
            return types_1.DATA_TYPE.NUMBER;
        case "string":
            if (value.format === types_1.DATA_TYPE.DATETIME) {
                return types_1.DATA_TYPE.DATETIME;
            }
            return types_1.DATA_TYPE.TEXT;
        default:
            return types_1.DATA_TYPE.NULL;
    }
};
var transformFilters = function (schemaFilters, custom) {
    if (!schemaFilters || !custom) {
        return [];
    }
    var filters = [];
    schemaFilters.forEach(function (filter) {
        var key = filter.name.split("__")[0];
        var condition = filter.name.split("__")[1];
        if (condition === undefined) {
            key = filter.name;
        }
        switch (filter.type) {
            case "datetime":
            case "date-time":
                filters.push({
                    key: key,
                    title: (0, lodash_1.startCase)(key),
                    type: types_1.DATA_TYPE.DATETIME,
                    supported: [types_1.FILTER_CONDITION.ISNULL, types_1.FILTER_CONDITION.GTE, types_1.FILTER_CONDITION.LTE],
                    active: false,
                });
                break;
            case "boolean":
                filters.push({
                    key: key,
                    title: (0, lodash_1.startCase)(key),
                    type: types_1.DATA_TYPE.BOOLEAN,
                    supported: [types_1.FILTER_CONDITION.TRUE, types_1.FILTER_CONDITION.FALSE],
                });
                break;
            case "array":
                filters.push({
                    key: key,
                    title: (0, lodash_1.startCase)(key),
                    type: types_1.DATA_TYPE.TEXT,
                    supported: [types_1.FILTER_CONDITION.IN, types_1.FILTER_CONDITION.CONTAINS],
                });
                break;
            case "integer":
                filters.push({
                    key: key,
                    title: (0, lodash_1.startCase)(key),
                    type: types_1.DATA_TYPE.NUMBER,
                    supported: [types_1.FILTER_CONDITION.LTE, types_1.FILTER_CONDITION.EQUALS, types_1.FILTER_CONDITION.GTE],
                });
                break;
            case "string":
                if ((filter === null || filter === void 0 ? void 0 : filter.format) === "datetime") {
                    filters.push({
                        key: key,
                        title: (0, lodash_1.startCase)(key),
                        type: types_1.DATA_TYPE.DATETIME,
                        supported: [types_1.FILTER_CONDITION.ISNULL, types_1.FILTER_CONDITION.GTE, types_1.FILTER_CONDITION.LTE],
                        active: false,
                    });
                    break;
                }
                var idx = (0, lodash_1.findIndex)(filters, function (filter) { return filter.key === key; });
                if (idx !== -1) {
                    var supported = filters[idx].supported;
                    var type = types_1.DATA_TYPE.TEXT;
                    if (supported && condition) {
                        supported.push(condition);
                    }
                    filters[idx] = {
                        key: key,
                        title: (0, lodash_1.startCase)(key),
                        type: type,
                        supported: supported,
                        active: false,
                        options: filter.enum
                            ? filter.enum.map(function (v) {
                                return { value: v, label: (0, lodash_1.startCase)(v) };
                            })
                            : undefined,
                    };
                }
                else {
                    filters.push({
                        key: key,
                        title: (0, lodash_1.startCase)(key),
                        type: types_1.DATA_TYPE.TEXT,
                        supported: [types_1.FILTER_CONDITION.EQUALS],
                        active: false,
                    });
                }
                break;
            default:
                console.error("cannot handle filter schema type ".concat(filter.type));
        }
    });
    custom.forEach(function (row) {
        var idx = filters.findIndex(function (c) { return c.key === row.key; });
        if (idx !== -1) {
            filters[idx] = tslib_1.__assign(tslib_1.__assign({}, filters[idx]), row);
        }
        else {
            filters.push(row);
        }
    });
    return (0, lodash_1.uniqBy)(filters, "key");
};
exports.transformFilters = transformFilters;
var getOrderedColumnsKeys = function (cols) {
    var columns = [];
    cols.forEach(function (val) {
        if (val.isVisible) {
            columns.push({ key: val.key, width: val.width });
        }
    });
    return columns;
};
exports.getOrderedColumnsKeys = getOrderedColumnsKeys;
var getExportableFields = function (cols) {
    // TODO refactor to use export key in definition
    var columns = [];
    cols
        .filter(function (column) { return (column === null || column === void 0 ? void 0 : column.exportable) === true || (column === null || column === void 0 ? void 0 : column.exportable) == undefined; })
        .forEach(function (val) {
        if (val.isVisible === true) {
            columns.push((val === null || val === void 0 ? void 0 : val.export_key) || val.key);
        }
    });
    return columns;
};
exports.getExportableFields = getExportableFields;
var getOrderedColumns = function (keys, cols) {
    cols === null || cols === void 0 ? void 0 : cols.forEach(function (col) {
        if (!col) {
            return;
        }
        var found = false;
        var width = 0;
        keys === null || keys === void 0 ? void 0 : keys.forEach(function (key) {
            // backwards compatibility, can remove in the future.
            if ((key.key || key) === col.key) {
                width = key.width;
                found = true;
            }
        });
        col.isVisible = found || col.fixed === true;
        col.width = width || col.width;
    });
    return sortColumns(cols, (0, lodash_1.map)(keys, function (k) { return k.key; }).reverse());
};
exports.getOrderedColumns = getOrderedColumns;
var groupColumns = function (columns) {
    return {
        ungrouped: columns.filter(function (c) { return !c.group; }),
        grouped: (0, lodash_1.groupBy)(columns.filter(function (c) { return c.group; }), function (val) { return val.group; }),
    };
};
exports.groupColumns = groupColumns;
var applyFiltersToURL = function (key, value, router) {
    var currentURL = new URL(window.location.href);
    currentURL.searchParams.set(key, value);
    router === null || router === void 0 ? void 0 : router.push(currentURL.toString(), "");
};
exports.applyFiltersToURL = applyFiltersToURL;
var applyDateFiltersToURL = function (key, values, router) {
    var currentURL = new URL(window.location.href);
    values.map(function (val) {
        currentURL.searchParams.set(key.concat(val.condition), val.value);
    });
    router.push(currentURL.toString(), "");
};
exports.applyDateFiltersToURL = applyDateFiltersToURL;
var removeFiltersFromURL = function (keys, router) {
    var currentURL = new URL(window.location.href);
    keys.forEach(function (k) { return currentURL.searchParams.delete(k); });
    router === null || router === void 0 ? void 0 : router.push(currentURL.toString(), "", { shallow: true });
};
exports.removeFiltersFromURL = removeFiltersFromURL;
var removeAllFiltersFromURL = function (router) {
    router === null || router === void 0 ? void 0 : router.push(router.pathname);
};
exports.removeAllFiltersFromURL = removeAllFiltersFromURL;
var fetchParamsInURL = function () {
    var currentURL = new URL(window.location.href);
    var results = {}; // TODO?
    currentURL.searchParams.forEach(function (value, key) {
        var _a, _b, _c, _d, _e;
        var keys = key === null || key === void 0 ? void 0 : key.split("__");
        var val = value;
        var condition = keys[keys.length - 1];
        if (!Object.values(types_1.FILTER_CONDITION).includes(condition)) {
            condition = "=";
        }
        var fkey = keys
            .filter(
        // @ts-expect-error
        function (k) { return !Object.values(types_1.FILTER_CONDITION).includes(k); })
            .join("__");
        if (results[fkey]) {
            var res = (_b = (_a = results[fkey]) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.split(",");
            res.push(value);
            val = res;
            condition = (_e = (_d = (_c = results[fkey]) === null || _c === void 0 ? void 0 : _c.condition) === null || _d === void 0 ? void 0 : _d.toString()) === null || _e === void 0 ? void 0 : _e.split(",");
            condition.push(keys[keys.length - 1]);
        }
        if (keys.length === 1) {
            condition = "=";
        }
        results[fkey] = {
            value: val.toString(),
            condition: condition,
        };
    });
    return results;
};
exports.fetchParamsInURL = fetchParamsInURL;
var urlParamsToFilters = function (params, initialFilters) {
    var _a, _b;
    if (initialFilters === void 0) { initialFilters = []; }
    var columnsFilters = [];
    Object.keys(params).map(function (key) {
        initialFilters.map(function (filter) {
            var _a;
            if (key === filter.key) {
                var value = params[key].value;
                var label = value;
                if (filter.type === types_1.DATA_TYPE.CHOICE) {
                    var comparator = value.split(",");
                    var tmpLabel_1 = [];
                    comparator.map(function (v) {
                        var _a, _b;
                        tmpLabel_1.push((_b = (_a = filter === null || filter === void 0 ? void 0 : filter.options) === null || _a === void 0 ? void 0 : _a.find(function (val) { return val.value === v; })) === null || _b === void 0 ? void 0 : _b.label);
                    });
                    label = tmpLabel_1.toString();
                    if (filter === null || filter === void 0 ? void 0 : filter.autoComplete) {
                        label = "";
                    }
                }
                if (filter.type === types_1.DATA_TYPE.DATETIME) {
                    value = (0, lodash_1.isEmpty)(value)
                        ? []
                        : value.split(",").map(function (v) {
                            return (0, exports.parseDateWithoutTimeZones)(v);
                        });
                }
                columnsFilters.push(tslib_1.__assign(tslib_1.__assign({}, filter), { condition: (_a = params === null || params === void 0 ? void 0 : params[key]) === null || _a === void 0 ? void 0 : _a.condition, value: value, label: label }));
            }
        });
    });
    return {
        columnsFilters: columnsFilters,
        search: (_a = params === null || params === void 0 ? void 0 : params.search) === null || _a === void 0 ? void 0 : _a.value,
        sortKey: (_b = params === null || params === void 0 ? void 0 : params.sort) === null || _b === void 0 ? void 0 : _b.value,
    };
};
exports.urlParamsToFilters = urlParamsToFilters;
var convertDateToString = function (filters) { return tslib_1.__spreadArray([], filters.map(function (filter) {
    var _a, _b, _c, _d;
    if (filter.type === types_1.DATA_TYPE.DATETIME && !(0, lodash_1.isEmpty)(filter.value)) {
        return tslib_1.__assign(tslib_1.__assign({}, filter), { value: [(_b = (_a = filter.value) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.toString(), (_d = (_c = filter.value) === null || _c === void 0 ? void 0 : _c[1]) === null || _d === void 0 ? void 0 : _d.toString()] });
    }
    if ((0, lodash_1.isArray)(filter.value)) {
        return tslib_1.__assign(tslib_1.__assign({}, filter), { value: filter.value.slice() }); // dereference array values
    }
    return tslib_1.__assign(tslib_1.__assign({}, filter), { value: filter.value });
}), true); };
exports.convertDateToString = convertDateToString;
var parseDate = function (date) {
    if (!date) {
        return (0, dayjs_1.default)();
    }
    return (0, dayjs_1.default)(date);
};
exports.parseDate = parseDate;
var parseDateWithoutTimeZones = function (date) {
    if (date === void 0) { date = null; }
    if (!date)
        return (0, dayjs_1.default)();
    // @ts-ignore
    return dayjs_1.default.utc(date);
};
exports.parseDateWithoutTimeZones = parseDateWithoutTimeZones;
var formatDate = function (date) {
    if (!date) {
        return "";
    }
    return (0, dayjs_1.default)(date).format("DD.MM.YYYY");
};
exports.formatDate = formatDate;
var formatTime = function (time) {
    if (!time) {
        return "";
    }
    return (0, dayjs_1.default)(time).format("HH:mm");
};
exports.formatTime = formatTime;
//# sourceMappingURL=utils.js.map